module.exports = __webpack_public_path__ + "img/202.e81a6c10.jpg";